import { render, staticRenderFns } from "./FiltersDashboardAduanas.vue?vue&type=template&id=140d8fba&"
import script from "./FiltersDashboardAduanas.vue?vue&type=script&lang=js&"
export * from "./FiltersDashboardAduanas.vue?vue&type=script&lang=js&"
import style0 from "./FiltersDashboardAduanas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140d8fba')) {
      api.createRecord('140d8fba', component.options)
    } else {
      api.reload('140d8fba', component.options)
    }
    module.hot.accept("./FiltersDashboardAduanas.vue?vue&type=template&id=140d8fba&", function () {
      api.rerender('140d8fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/dashboard/views/components/FiltersDashboardAduanas.vue"
export default component.exports